import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import ResidentialStoragePage from '@/v2/components/pages/public-pages/residential-storage-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/residential-storage-page'

interface ResidentialStoragePageProps {}

const Page: React.FC<ResidentialStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.residential_storage.title ?? ''}
        keywords={META_CONTENTS.residential_storage?.keywords ?? ''}
        description={META_CONTENTS.residential_storage?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <ResidentialStoragePage />
    </>
  )
}

export default Page
